import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetThreadExistsInNewKim = (matterId: string, subsetId: string, threadId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getThreadExistsInNewKim = async (): Promise<boolean> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/${threadId}/exists-in-new-kim`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching thread exists in new kim failed');
    }
    return response.json();
  };

  return useQuery([QueryEntity.KimThreadExistsInNewKim, { threadId }], getThreadExistsInNewKim, {
    enabled: !!matterId && !!subsetId && !!threadId,
    refetchOnWindowFocus: false,
  });
};
